import {BaseService} from './BaseService';
export default class HighlightsService extends BaseService {

  postHighlights(highlights) {
    console.log(highlights);
    const url = new URL(`${this.domain}/highlights`);
    return this.fetch(url, {
      method: 'POST',
      body: JSON.stringify({ highlights}),
    })
    .then(res => {
      return Promise.resolve(res);
    });
  }

  getHighlights(id) {
    const url = new URL(`${this.domain}/highlights?id=${id}`);
    return this.fetch(url, {
      method: 'GET',
    })
    .then(res => {
      return Promise.resolve(res);
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/HighlightsService.js